import {
  CenterTeflCost,
  CenterTeflCostInput
} from '../../../lib/types/models/center/center-tefl-cost'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export function updateCenterTeflCosts(id: number, data: CenterTeflCostInput[]) {
  return restApiClient
    .url(constructApiUrl(API.centers.updateCenterTeflCosts.url, { id }))
    .patch<CenterTeflCost[], CenterTeflCostInput[]>(data)
}
